export const V1_RECEIVE_SEARCH_RESULTS = 'V1_RECEIVE_SEARCH_RESULTS'

export default data => {
  return {
    type: V1_RECEIVE_SEARCH_RESULTS,
    data,
  }
}
